import { render } from "./NotFoundComponent.vue?vue&type=template&id=31c75f19&scoped=true"
import script from "./NotFoundComponent.vue?vue&type=script&lang=js"
export * from "./NotFoundComponent.vue?vue&type=script&lang=js"

import "./NotFoundComponent.vue?vue&type=style&index=0&id=31c75f19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c75f19"]])

export default __exports__